// src/components/Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/GCSoftwareDev.svg';

const navLinks = [
  { href: '/#why-choose-us', label: 'Why Choose Us' },
  { href: '/#services', label: 'Services' },
  { href: '/#recently-completed-projects', label: 'Our Work' },
  { href: '/contact#what-to-expect', label: 'What to Expect' },
];

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-white/90 backdrop-blur py-4 fixed w-full top-0 z-20 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between relative">
        <Link
          to="/"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="flex items-center"
        >
          <img
            src={logo}
            alt="Golden Coast Software Development Logo"
            className="h-12 sm:h-16 w-auto"
          />
        </Link>

        <div className="hidden md:flex items-center space-x-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-lg font-semibold text-gray-800 hover:text-blue-600 transition"
            >
              {link.label}
            </a>
          ))}
          <Link
            to="/contact"
            className="text-lg font-semibold text-white bg-blue-600 px-4 py-2 rounded-lg shadow-md hover:bg-blue-700 hover:shadow-lg transition duration-300"
          >
            Contact
          </Link>
        </div>

        <button
          className="md:hidden text-gray-800 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600 p-2"
          aria-label={mobileMenuOpen ? 'Close Menu' : 'Open Menu'}
          aria-expanded={mobileMenuOpen}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            {mobileMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="absolute top-full left-0 w-full bg-white shadow-md py-4 px-6 md:hidden">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="block text-lg font-semibold text-gray-800 hover:text-blue-600 transition mb-4"
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <Link
            to="/contact"
            className="block text-center text-lg font-semibold text-white bg-blue-600 px-4 py-2 rounded-lg shadow-md hover:bg-blue-700 transition duration-300"
            onClick={() => setMobileMenuOpen(false)}
          >
            Contact
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Header;
